export default {
  labels: {
    selectOne: 'Selecione uma opção',
    selectAll: 'Selecione todas as opções aplicáveis',
    typeResponse: 'Insira sua resposta na caixa de texto abaixo.',
    recordResponse: 'Faça uma gravação para responder à pergunta.',
    enterNumeric: 'Insira um valor numérico no campo abaixo.',
    rateResponseScale: 'Avalie sua resposta na escala fornecida.',
    sliderMinimum: 'Valor mínimo: {value}',
    sliderMaximum: 'Valor máximo: {value}',
    selectOneOptionRow: 'Selecione uma opção por cada linha.',
    selectAllOptionsRow: 'Selecione todas as opções aplicáveis por cada linha.',
    dragAndDropResponse: 'Arraste e solte as opções para classificá-las por ordem de preferência.',
    rankOrderDesktopInstruction: 'Arraste e solte itens para classificá-los, ou use o botão + para adicionar um item à lista. Use os botões de seta para reordenar ou o botão de exclusão para remover um item.',
    alert: 'Atenção',
    minMaxError: 'Insira um número entre {min} e {max}.',
    cameras: 'Câmeras',
    microphones: 'Microfones',
    recording: 'Gravação',
    noDevicesFound: 'Nenhum dispositivo encontrado',
    camera: 'Câmera',
    microphone: 'Microfone',
    stopRecording: 'Parar a gravação',
    startRecording: 'Iniciar a gravação',
    disableCamera: 'Desativar câmera',
    enableCamera: 'Ativar câmera',
    disableMicrophone: 'Desativar microfone',
    enableMicrophone: 'Ativar microfone',
    settings: 'Configurações',
    recordingProgress: 'Progresso da gravação',
    playbackProgress: 'Progresso da reprodução',
    play: 'Reproduzir',
    pause: 'Pausar',
    stop: 'Parar',
    record: 'Gravar',
    recordAgain: 'Gravar novamente',
    retry: 'Tentar novamente',
    done: 'Feito',
    minRecordTime: 'Grave uma resposta de {min} segundos.',
    taggingAlert: 'Esta pergunta é apresentada aqui para fins de teste. Essa informação ficará oculta para todos os participantes quando a pesquisa for lançada.',
    tagsCaptured: 'Tags capturadas:',
    enlargeImage: 'Ampliar imagem',
    enlargedImage: 'Imagem ampliada',
    close: 'Fechar',
    zoomIn: 'Aumentar zoom',
    zoomOut: 'Diminuir zoom',
    resetZoom: 'Redefinir zoom',
    zoomLevel: 'Zoom {percentage}%',
    imagePosition: '{current} de {total}',
    previousImage: 'Imagem anterior',
    nextImage: 'Próxima imagem',
    imageLoading: 'Carregando imagem',
    imageLoadFailed: 'Não foi possível carregar a imagem',
  },
  noSelection: 'Sem seleção',
  actions: {
    increase: 'Aumentar',
    decrease: 'Diminuir'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Pré-visualização da Pesquisa Encerrada',
      titleCompleted: 'Pré-visualização da Pesquisa Concluída',
      previewModeWarning: 'Esta página só é visível no Modo de Pré-visualização e não será mostrada aos respondentes reais.',
      reachedEndPoint: 'Esta pesquisa chegou a um ponto final.',
      reachedEndPointCompleted: 'Esta pré-visualização chegou a um ponto final.',
      returnToModify: 'Volte à pergunta anterior para modificar suas respostas e testar um caminho de pesquisa diferente.',
      logic: 'Lógica'
    }  }
}
